// extracted by mini-css-extract-plugin
module.exports = {"root":"_8ea801","icon":"_5de51a"};